"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var contact_1 = require("../../services/contact");
var react_1 = __importStar(require("react"));
var ContactForm = function () {
    var _a = react_1.useState(''), email = _a[0], setEmail = _a[1];
    var validateInput = function () {
        if (email.length < 0)
            return;
        contact_1.sendContactForm({ email: email, message: 'test' });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", { type: "email", onChange: function (event) {
                setEmail(event.target.value);
            }, placeholder: "Email" }),
        react_1.default.createElement("button", { onClick: validateInput }, "Senden")));
};
exports.default = ContactForm;
//# sourceMappingURL=ContactForm.js.map